import { render, staticRenderFns } from "./AdminUserAcademyList.vue?vue&type=template&id=5ec72488&scoped=true&lang=pug&"
import script from "./AdminUserAcademyList.vue?vue&type=script&lang=ts&"
export * from "./AdminUserAcademyList.vue?vue&type=script&lang=ts&"
import style0 from "./AdminUserAcademyList.vue?vue&type=style&index=0&id=5ec72488&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec72488",
  null
  
)

export default component.exports